<template>
  <div class="add-account-form-container">
    <h3>Buka Rekening Baru</h3>
    <form @submit.prevent="handleAddAccount">
      <div class="form-group">
        <label for="accountType">Pilih Jenis Rekening:</label>
        <select v-model="accountType" id="accountType" required>
          <option value="Tabungan">Tabungan</option>
          <option value="Giro">Giro</option>
          <option value="Tabungan Berjangka">Tabungan Berjangka</option>
          <!-- Tambahkan jenis rekening lain jika ada -->
        </select>
      </div>

      <button type="submit" :disabled="isSubmitting" class="btn btn-primary">
        {{ isSubmitting ? 'Memproses...' : 'Buka Rekening' }}
      </button>

      <p v-if="error" class="error-message">{{ error }}</p>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import api from '@/services/api';
import { useToast } from 'vue-toastification';

const emit = defineEmits(['account-added']);
const toast = useToast();

const accountType = ref('Tabungan'); // Nilai default
const isSubmitting = ref(false);
const error = ref(null);

const handleAddAccount = async () => {
  isSubmitting.value = true;
  error.value = null;

  try {
    await api.createAccount({ account_type: accountType.value });
    toast.success(`Rekening ${accountType.value} baru berhasil dibuka!`);
    emit('account-added'); // Kirim event ke induk untuk refresh
  } catch (err) {
    console.error("Gagal membuka rekening:", err);
    error.value = "Gagal membuka rekening baru. Silakan coba lagi.";
    toast.error(error.value);
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<style scoped>
.add-account-form-container {
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #f9f9f9;
  border-radius: 8px;
}
.error-message {
  color: red;
  margin-top: 1rem;
}
</style>